import { appInfo } from "@/common/data";
export default [
  {
    path: "/MWYWk3O3hrsG",
    name: "faculties",
    meta: {
      title: appInfo?.type === "codsmsi" ? "Schools" : "Sections",
      authRequired: true,
      acc: ["v27", "v93", "v87"],
    },
    component: () => import("@/views/faculties/faculties-list"),
  },

  {
    path: "/etvm4ty54euv7hgyjyyje",
    name: "assign-faculties",
    meta: {
      title: appInfo?.type === "codsmsi" ? "Assign school" : "Assign section",
      authRequired: true,
      acc: ["v27", "v93", "v87"],
    },
    component: () => import("@/views/faculties/assign.vue"),
  },
  {
    path: "/etvm4ty54euv7hgyjyyjexowoRFKEn5hw",
    name: "assigned-faculties",
    meta: {
      title:
        appInfo?.type === "codsmsi" ? "Assigned schools" : "Assigned sections",
      authRequired: true,
      acc: ["v27", "v93", "v87"],
    },
    component: () => import("@/views/faculties/assigned.vue"),
  },
  {
    path: "/Mcnqw6OQgeqY",
    name: "new-faculty",
    meta: {
      title: appInfo?.type === "codsmsi" ? "New school" : "New section",
      authRequired: true,
      acc: ["v44"],
    },
    component: () => import("@/views/faculties/new-faculty"),
  },
  {
    path: "/adaifhirnwcifuyriycner/:faculty?",
    name: "gt-faculty",
    meta: {
      title: appInfo?.type === "codsmsi" ? "School" : "Section",
      authRequired: true,
      acc: ["v83"],
    },
    component: () => import("@/views/faculties/view"),
  },
  {
    path: "/ibuytuyybtnyug8ihtutujfacult/:faculty?",
    name: "edit-faculty",
    meta: {
      title: appInfo?.type === "codsmsi" ? "Edit school" : "Edit section",
      authRequired: true,
      acc: ["v83"],
    },
    component: () => import("@/views/faculties/edit.vue"),
  },
];
